import script from "./AddTenantWizard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddTenantWizard.vue?vue&type=script&lang=ts&setup=true"

import "./AddTenantWizard.vue?vue&type=style&index=0&id=4c92995b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c92995b"]])

export default __exports__